import axios from "axios";

export const CHANNEL_URL = "https://www.youtube.com/@royalholidayspvt";
export const fetchVideos = () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/videos`).then((r) => r.data.videos);
export const cleanTitle = (t) => t.replace(/#\S+/g, "").replace(/\s*\|\s*$/, "").replace(/\s{2,}/g, " ").trim();
export const fmtViews = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}K` : n);
export const thumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
